<template>
  <div class="franchise js">
    <!-- <div class="franchise-section">
      <div id="breadcrumbs">
        <nav class="breadcrumbs">
          <span class="breadcrumbs-item">
            <a href="/">
              <span>{{ $t('new.home') }}</span>
            </a>
          </span>
          <span class="breadcrumb-divider" aria-hidden="true">/</span>
        </nav>
      </div>
    </div> -->
    <div class="franchise-section">
      <div class="franchise-section-cont1 animated fadeIn">
        <div>
          <div class="cont1-bk">
            <div class="cont1-bk-inner">
              <div class="cont1-bk-inner-cont">
                <div class="cont1-bk-inner-cont-font" data-animate data-animate-order="3">
                  <p v-if="topData && topData?.value">
                    <strong>{{ topData?.value[0].title }}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="franchise-section">
      <div class="franchise-section-cont2">
        <div class="franchise-section-cont2-inner" v-if="topData && topData?.value">
          <div class="franchise-section-cont2-inner-cont kb-enabled in-viewport">
            <div class="franchise-section-cont2-inner-cont-left">
              <div class="franchise-section-cont2-inner-cont-left-box">
                <div class="franchise-section-cont2-inner-cont-left-box-font">
                  <p>
                    <strong>{{ topData?.value[0]?.small_money }}</strong>
                    <strong>{{ topData?.value[0]?.big_billion }}</strong>
                  </p>

                  <h5>{{ topData?.value[0]?.small_des }}</h5>
                  <!-- <h5>Market</h5> -->
                </div>
              </div>
              <div class="franchise-section-cont2-inner-cont-left-font">
                <p>{{ topData?.value[0]?.source }}</p>
                <!-- <p>Grand View Research, 2024</p> -->
              </div>
            </div>
            <div class="franchise-section-cont2-inner-cont-right">
              <div class="franchise-section-cont2-inner-cont-right-box">
                <span class="boxSpan"></span>
                <div class="franchise-section-cont2-inner-cont-right-box-font">
                  <p>
                    <strong>{{ topData?.value[0]?.big_money }}</strong>
                    <strong>{{ topData?.value[0]?.big_billion }}</strong>
                  </p>

                  <h5>{{ topData?.value[0]?.big_des }}</h5>
                </div>
              </div>
              <div class="franchise-section-cont2-inner-cont-right-font">
                <p>{{ topData?.value[0]?.big_outside }} <strong>{{ topData?.value[0]?.big_outside_number }}</strong></p>
                <p>{{ topData?.value[0]?.big_outside_number_last }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="franchise-section">
      <div class="franchise-section-cont1-title">
        <div class="franchise-section-cont1-title-text animated fadeIn">
          <div class="franchise-section-cont1-title-text-cont">
            <div class="franchise-section-cont1-title-text-cont-margin">
              <h2 data-animate data-animate-order="1" v-if="development_history && development_history?.value">{{
                development_history?.value[0]?.title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="franchise-section">
      <div class="timeline-container">
        <div class="timeline-container-cont kb-enabled in-viewport">
          <div class="timeline-items" v-if="isDesktop && development_history && development_history?.value">
            <div class="timeline-item" v-for="(item, index) in development_history?.value[0]?.content" :key="index">
              <div class="timeline-top">
                <div class="timeline-year">{{ item.year }}</div>
                <div style="width: 100%;">
                  <div class="timeline-badge">{{ item.subheading }}</div>
                </div>
              </div>
              <div class="timeline-line"></div>
              <div class="timeline-content">
                <div class="timeline-dot-cont">
                  <div class="timeline-dot">
                    <div class="timeline-box"></div>
                  </div>
                </div>
                <div class="timeline-card">
                  <div class="card-content">
                    <el-timeline>
                      <el-timeline-item v-for="(paragraph, pIndex) in item.year_content" :key="pIndex">
                        <p v-html="paragraph.year_content"></p>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="timeline" v-else-if="!isDesktop && development_history && development_history?.value">
            <!-- developmentHistory.timeline -->
            <div class="timeline-item" v-for="(item, index) in development_history?.value[0]?.content" :key="index">
              <div class="timeline-dot">
              </div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <div class="timeline-year">{{ item.year }}</div>
                  <div class="timeline-tag">{{ item.subheading }}</div>
                </div>
                <div class="timeline-description">
                  <div class="description-item" v-for="(paragraph, pIndex) in item.year_content" :key="pIndex">
                    <p v-html="paragraph.year_content"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="franchise-section">
      <div class="franchise-section-cont3 animated fadeIn">
        <div class="franchise-section-cont3-cont">
          <div class="franchise-section-cont3-cont-inner" v-if="vision && vision?.value">
            <div class="franchise-section-cont3-cont-inner-title">{{ vision?.value[0]?.title }}</div>
            <div class="franchise-section-cont3-cont-inner-font" v-html="vision?.value[0]?.content"></div>
            <!-- <div class="franchise-section-cont3-cont-inner-font">
              <h3>Shaping the Global Standard in Scalp & Hair Wellness</h3>
            </div>
            <div class="franchise-section-cont3-cont-inner-font">
              <p>
                <strong>Technology</strong>: Continue to strengthen global R&amp;D capabilities and bring innovative solutions to the market
              </p>
            </div>
            <div class="franchise-section-cont3-cont-inner-font">
              <p>
                <strong>Expansion</strong>: Grow our presence across key international regions with sustainable strategies
              </p>
            </div>
            <div class="franchise-section-cont3-cont-inner-font">
              <p>
                <strong>ESG</strong>: Build a responsible and future-ready business through smarter operations and global collaboration
              </p>
            </div> -->
            <div class="franchise-section-cont3-cont-inner-image"
              :style="{ transform: `translate3d(0px, ${parallaxValue}%, 0px)` }">
              <div class="franchise-section-cont3-cont-inner-image-box">
                <div class="franchise-section-cont3-cont-inner-image-box-center">
                  <img loading="lazy" class="theme-img js" alt="" :srcset="`
                  ${require('@/assets/assetsNew/franchise/p1.png')} 550w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 750w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 1100w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 1445w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 1680w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 2048w,
                  ${require('@/assets/assetsNew/franchise/p1.png')} 2060w`" sizes="50vw"
                    :src="require('@/assets/assetsNew/franchise/p1.png')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="franchise-section">
      <div class="franchise-section-cont4 animated fadeIn">
        <div class="franchise-section-cont4-titles">
          <h2 data-animate data-animate-order="1">{{ $t('franchise.titleNew') }}</h2>
          <div data-animate data-animate-order="2" class="franchise-section-cont4-titles-font">
            <h5>{{ $t('franchise.titleNew1') }}</h5>
          </div>
        </div>
        <div data-animate data-animate-order="3">
          <div class="franchise-section-text">
            <div>
              <form @submit.prevent="submitForm" id="franchiseForm">
                <div class="form-item">
                  <label for="name">{{ $t('new.name') + ' *' }}</label>
                  <input type="text" name="name" :placeholder="$t('new.name') + ' *'" id="name" aria-labelledby="name"
                    data-aid="name-input" required aria-required maxlength>
                </div>
                <div class="form-item">
                  <label for="email">{{ $t('new.email') + ' *' }}</label>
                  <input type="email" name="email" :placeholder="$t('new.email') + ' *'" id="email"
                    aria-labelledby="email" data-aid="email-input" required aria-required maxlength
                    pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$" title="请输入有效的邮箱地址">
                </div>
                <div class="form-item">
                  <label for="phone">{{ $t('new.phone') + ' *' }}</label>
                  <input type="tel" name="phone" :placeholder="$t('new.phone') + ' *'" id="phone"
                    aria-labelledby="phone" data-aid="phone-input" required aria-required maxlength="20"
                    pattern="[\+]?[0-9]{1,4}[\s\-]?[0-9]{7,15}" title="请输入有效的电话号码">
                </div>
                <div class="form-item">
                  <label for="location">{{ $t('new.location') + ' *' }}</label>
                  <input type="text" name="location" :placeholder="$t('new.location') + ' *'" id="location"
                    aria-labelledby="location" data-aid="location-input" required aria-required maxlength>
                </div>
                <div class="form-item form-item-full">
                  <label for="location">{{ $t('new.message') + ' *' }}</label>
                  <textarea name="message" :placeholder="$t('new.message') + ' *'" id="message"
                    aria-labelledby="message" data-aid="message-input" rows="10" required maxlength></textarea>
                </div>
                <div class="franchise-btn">
                  <button type="submit" class="btn">{{ $t('new.send') }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDataList, submitQuestion } from '@/api/komo'
export default {
  data() {
    return {
      franchiseList: [],
      windowWidth: 0,
      parallaxValue: 0,
      tickimg: false,
      topData: {},
      development_history: {},
      vision: {},
    }
  },
  async created() {
    await this.initData();
    // 初始化窗口宽度
    this.windowWidth = window.innerWidth;
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= 1300;
    }
  },
  mounted() {
    // 添加窗口大小变化监听器
    window.addEventListener('resize', this.handleWindowResize);
    // 添加滚动监听器
    window.addEventListener('scroll', this.handleScroll);


  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async submitForm() {
      const form = document.getElementById('franchiseForm');
      // 检查表单有效性
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const formData = new FormData(form);
      // 将 FormData 转换为普通对象
      const formDataObj = {};
      for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
      }
      console.log(formDataObj)
      let params = {
        body_option: "franchisee",
        full_name: formDataObj.name,
        mobile: formDataObj.phone,
        email: formDataObj.email,
        preferred_city: formDataObj.location,
        message: formDataObj.message
      }

      try {
        // 使用导入的 submitQuestion 方法提交表单数据
        const response = await submitQuestion(params);

        if (response && response.error === 0) {
          // 提交成功处理
          const successMessage = response.message || '提交成功！';
          this.$message.success(successMessage);
          form.reset();
        } else {
          // 提交失败处理
          const errorMessage = response?.message || response?.errors || '提交失败，请重试';
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error('提交出错:', error);
        // 检查是否有响应数据
        if (error.response && error.response.data) {
          const errorMsg = error.response.data.message ||
            error.response.data.errors ||
            '提交出错，请重试';
          this.$message.error(errorMsg);
        } else {
          this.$message.error('网络错误，请检查网络连接后重试');
        }
      }
    },
    async initData() {
      const franchiseDatalist = await getDataList(localStorage.getItem('pageId'));
      this.franchiseList = franchiseDatalist?.data?.list;
      this.franchiseList.forEach((item) => {
        if (item.code == "top") {
          this.topData = item;
        } else if (item.code == "development_history") {
          this.development_history = item;
        } else if (item.code == "vision") {
          this.vision = item;
        }
      })



      this.$nextTick(() => {
        this.initIntersectionObserver();
      });
    },
    initIntersectionObserver() {
      // 获取所有需要观察的元素（包括图片和文字）
      const imageElements = this.$el.querySelectorAll('.kb-enabled');
      const textElements = this.$el.querySelectorAll('[data-animate]');
      const allElements = [...imageElements, ...textElements];

      if (allElements.length > 0) {
        // 移除所有元素的初始动画类
        imageElements.forEach(element => {
          element.classList.remove('in-viewport');
        });

        textElements.forEach(element => {
          element.classList.remove('animate-trigger');
        });

        // 创建交叉观察器
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const element = entry.target;

            if (entry.isIntersecting) {
              // 元素进入视口
              // 如果是图片元素
              if (element.classList.contains('kb-enabled')) {
                element.classList.add('in-viewport');
              }
              // 如果是文字元素
              else if (element.hasAttribute('data-animate')) {
                // 添加动画触发类
                element.classList.add('animate-trigger');
              }
            } else {
              // 元素离开视口（支持重复动画）
              if (element.classList.contains('kb-enabled')) {
                element.classList.remove('in-viewport');
              } else if (element.hasAttribute('data-animate')) {
                element.classList.remove('animate-trigger');
              }
            }
          });
        }, {
          threshold: 0.1, // 当10%的元素可见时触发
          rootMargin: '0px 0px -50px 0px' // 提前50px触发
        });

        // 开始观察所有元素
        allElements.forEach(element => {
          observer.observe(element);
        });
      }
    },
    // 处理窗口大小变化
    handleWindowResize() {
      this.windowWidth = window.innerWidth;
    },
    // 滚动事件处理
    handleScroll() {
      if (!this.ticking) {
        requestAnimationFrame(this.updateParallax);
        this.ticking = true;
      }
    },
    // 更新视差值
    updateParallax() {
      const section = this.$el.querySelector('.franchise-section-cont3');
      if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // 计算元素在视口中的位置
        const sectionTop = rect.top + scrollTop;
        const windowHeight = window.innerHeight;

        // 只在元素接近视口时计算视差
        if (rect.top < windowHeight && rect.bottom > 0) {
          // 调整偏移基准值，增加一个偏移量
          const offset = 100; // 添加偏移量
          // 计算视差值，基于元素在视口中的位置
          const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
          // 添加负号实现反向移动效果
          this.parallaxValue = -(progress * 300) + offset; // 添加负号实现反向移动
        }
      }
      this.ticking = false;
    }
  }
}
</script>
<style scoped lang="scss">
.franchise {
  padding: var(--nav-max-height) 0 0;
  display: block;

  .franchise-section {
    width: 100%;

    #breadcrumbs {
      margin: 0;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-left: 60px;
      padding-right: 60px;

      .breadcrumbs {
        font-size: 0;

        .breadcrumbs-item {
          margin-right: 10px;
          display: inline-block;
          font-size: 12px;

          a {
            color: var(--font-color);

            span {
              display: inline-block;
              padding-bottom: 0;
              font-family: var(--label-font-stack);
              font-weight: var(--label-font-weight);
              font-style: var(--label-font-style);
              text-transform: var(--label-font-case);
              letter-spacing: var(--label-spacing);
            }
          }
        }

        .breadcrumb-divider {
          font-size: 12px;
        }
      }
    }

    .cont1-bk {
      display: grid;
      grid-template: 1fr / 1fr;
      overflow: hidden;
      position: relative;
      background: #64715d;

      .cont1-bk-inner {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        display: flex;
        height: 100%;
        position: relative;

        .cont1-bk-inner-cont {
          width: 100%;
          padding: 15px;

          .cont1-bk-inner-cont-font {
            color: #ffffff;

            p {
              font-size: 38px;
              line-height: normal;
              display: block;
              font-family: math;
              font-weight: var(--header-font-weight);
              font-style: var(--header-font-style);
              letter-spacing: var(--heading-spacing);
              text-transform: var(--heading-font-case);
              margin: 0 0 .5em;
              line-height: var(--heading-line-height);
            }
          }
        }
      }
    }

    .franchise-section-cont2 {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: minmax(0, auto);
      width: 100%;
      // height: 100%;
      height: 600px;
      will-change: transform;

      .franchise-section-cont2-inner {
        display: flex;
        align-items: center;
        justify-content: center;

        .franchise-section-cont2-inner-cont {
          width: 100%;
          height: 100%;

          .franchise-section-cont2-inner-cont-left {
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .franchise-section-cont2-inner-cont-left-box {
              width: 50vw;
              height: 50vw;
              border-radius: 50%;
              background: linear-gradient(135deg, #345e4b, #457a64);
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;

              .franchise-section-cont2-inner-cont-left-box-font {
                color: #fff;

                p {
                  display: flex;
                  flex-direction: column;
                  font-family: system-ui;
                  font-weight: var(--body-font-weight);
                  font-style: var(--body-font-style);
                  -webkit-font-smoothing: antialiased;
                  -webkit-text-size-adjust: 100%;
                  align-items: center;

                  strong {
                    font-size: 38px;

                    &:first-child {
                      font-size: 50px;
                    }
                  }
                }

                h5 {
                  font-family: system-ui;
                  font-weight: var(--body-font-weight);
                  font-style: var(--body-font-style);
                  -webkit-font-smoothing: antialiased;
                  -webkit-text-size-adjust: 100%;
                  text-align: center;
                }
              }
            }

            .franchise-section-cont2-inner-cont-left-font {
              font-family: var(--bs-body-font-family);

              p {
                &:first-child {
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }

    .franchise-section-cont1-title {
      padding-top: 30px;
      padding-bottom: 12px;

      .franchise-section-cont1-title-text-cont {
        position: relative;
        display: inline-block;
        width: 100%;
        vertical-align: top;

        .franchise-section-cont1-title-text-cont-margin {
          max-width: 920px;
          margin: 0 auto;
          text-align: center;

          h2 {
            font-size: 30px;
            color: var(--font-color);
          }
        }
      }
    }

    .timeline-container {
      width: 100%;
      background: #d5dcc880;
      margin: 0 auto;
      padding-bottom: 7vw;
    }

    .timeline-container-cont {
      position: relative;
      width: 80%;
      height: 100%;
      margin: 0 auto;
      padding: 4% 3%;
    }

    .timeline-items {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 2;

      .timeline-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        width: calc(100% / 3);
      }

      .timeline-top {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 62%;
      }

      .timeline-line {
        height: 6px;
        background: #64715d3b;
        width: 100%;
      }

      .timeline-year {
        font-size: 3.5rem;
        font-weight: bold;
        color: #64715D;
        margin-bottom: 2%;
        letter-spacing: -0.02em;
        align-self: flex-start;
        text-align: center;
        width: 100%;
      }

      .timeline-badge {
        color: #1E1E1E;
        padding: 4% 5%;
        font-size: 0.8vw;
        font-weight: 600;
        margin-bottom: 3vw;
        white-space: nowrap;
        text-align: center;
        align-self: flex-start;
        background: #D5DCC8;
        border-radius: 30px;
        /* width: 9vw; */
        font-family: MicrosoftYaHei;
      }

      .timeline-dot-cont {
        width: 100%;
        padding-left: calc(1.3vw - 16px - 8px);
      }

      .timeline-dot {
        width: 64px;
        height: 64px;
        background: #64715d3b;
        border-radius: 50%;
        margin-bottom: 8%;
        box-shadow: 0 0 0 2px #D0D0D0;
        /* position: absolute;
        top: 140px;
        left: 0; */
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .timeline-box {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #64715D;
        position: relative;
      }

      .timeline-content {
        width: 100%;
        position: relative;
        padding-left: 0;
        display: flex;
        flex-direction: column;
        margin: -36px 2vw 0;
      }

      .timeline-card {
        background: #FFFFFF;
        border-radius: 20px;
        padding: 0;
        box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
        border: 1px solid #E8E8E8;
        min-height: 200px;
        width: 23vw;
      }

      .card-content {
        padding: 1.6vw 1.3vw;
      }

      .card-content .el-timeline {
        padding: 0;
      }

      .card-content :deep(.el-timeline-item__node) {
        background: #FFFFFF;
        border: 2px solid #64715D;
      }

      .card-content :deep(.el-timeline-item__node--normal) {
        width: 20px;
        height: 20px;
      }

      .card-content :deep(.el-timeline-item__tail) {
        left: 8px;
        border-left: 3px solid #64715D;
      }

      .card-content p {
        font-size: 1rem;
        line-height: 1.8;
        color: #1E1E1E;
        margin-bottom: 4%;
        text-align: left;
      }

      .card-content p:last-child {
        margin-bottom: 0;
      }
    }

    .timeline {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: 2.67vw;
        top: 1.33vw;
        bottom: 0;
        width: 0.53vw;
        background-color: #E0E0E0;
      }

      .timeline-item {
        position: relative;
        margin-bottom: 8vw;
        padding-left: 11.73vw;
      }

      .timeline-item:last-child {
        margin-bottom: 0;
      }

      .timeline-dot {
        position: absolute;
        left: 1.33vw;
        top: 1.33vw;
        width: 3vw;
        height: 3vw;
        background-color: #64715D;
        border-radius: 50%;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: 1.07vw solid #D5DCC8;
      }


      .timeline-content {
        border-radius: 2.67vw;
        position: relative;
      }

      .timeline-header {
        display: flex;
        align-items: center;
        margin-bottom: 3.2vw;
      }

      .timeline-year {
        font-size: 5.33vw;
        font-weight: bold;
        color: #64715D;
        margin: 0;
        margin-right: 2.13vw;
      }

      .timeline-tag {
        background-color: #D5DCC8;
        color: #1E1E1E;
        font-size: 3.2vw;
        padding: 1.33vw 2.67vw;
        border-radius: 4vw;
        margin: 0;
        font-weight: 500;
        flex-shrink: 0;
      }

      .timeline-description {
        margin-top: 4.27vw;
        background-color: #fff;
        padding: 3.2vw;
        border-radius: 2.67vw;
      }

      .description-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 3.2vw;
      }

      .description-item:last-child {
        margin-bottom: 0;
      }
    }

    .franchise-section-cont3 {
      position: relative;
      z-index: 10;
      overflow: hidden;

      .franchise-section-cont3-cont {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px 60px;

        * {
          margin: 0;
          margin-bottom: 0;
        }

        .franchise-section-cont3-cont-inner {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .franchise-section-cont3-cont-inner-title {
            padding-bottom: 25px;
            font-size: 80px;
            text-align: center;
            white-space: normal;
            word-break: break-word;
            display: block;
            font-family: math;
            font-weight: var(--header-font-weight);
            font-style: var(--header-font-style);
            letter-spacing: var(--heading-spacing);
            text-transform: var(--heading-font-case);
            line-height: var(--heading-line-height);
          }

          .franchise-section-cont3-cont-inner-font {
            padding-bottom: 20px;

            h3 {
              display: block;
              font-family: math;
              font-weight: var(--header-font-weight);
              font-style: var(--header-font-style);
              letter-spacing: var(--heading-spacing);
              text-transform: var(--heading-font-case);
              line-height: var(--heading-line-height);
              font-size: var(--h3-size);
              color: var(--font-color);
            }
          }

          .franchise-section-cont3-cont-inner-image {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            max-height: 100%;
            overflow: hidden;
            z-index: 20;
            transform: translateY(150%);
            will-change: transform;
            transition: transform 0.1s ease-out;

            .franchise-section-cont3-cont-inner-image-box {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%; /* 添加宽度 */

              .franchise-section-cont3-cont-inner-image-box-center {
                height: 100%;
                max-height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%; /* 添加宽度 */

                img {
                  object-fit: contain;
                  object-position: 50.0% 50.0%;
                  width: 100%;
                  height: 100%;
                  max-height: 100%;
                  max-width: 100%;
                  border: 0 none;
                }
              }
            }
          }
        }
      }
    }

    .franchise-section-cont4 {
      padding: 30px 10px;

      .franchise-section-cont4-titles {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 920px;
        margin: 0 auto 50px;
        font-family: math;
        font-weight: var(--header-font-weight);
        font-style: var(--header-font-style);
        letter-spacing: var(--heading-spacing);
        text-transform: var(--heading-font-case);
        line-height: var(--heading-line-height);

        h2 {
          font-size: var(--h2-size);
          margin: 0px;
          width: 100%;
          max-width: 70ch;
          text-align: center;
        }

        .franchise-section-cont4-titles-font {
          margin-top: 15px;
          width: 100%;
          max-width: 70ch;
          text-align: center;

          h5 {
            font-size: var(--h5-size);
            margin: 0;
          }
        }
      }

      .franchise-section-text {
        max-width: 920px;
        margin: 0 auto;

        form {
          display: flex;
          flex-wrap: wrap;
          row-gap: 15px;
          column-gap: 20px;
          margin-bottom: 0;

          .form-item {
            width: 100%;
            display: flex;
            flex-direction: column;

            label {
              position: absolute;
              width: 1px;
              height: 1px;
              padding: 0;
              margin: -1px;
              overflow: hidden;
              clip: rect(0, 0, 0, 0);
              border: 0;
              cursor: pointer;
            }

            input {
              color: var(--font-color);
              font-size: var(--base-font-size);
              line-height: 1.6;
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              background: 0 0;
              max-width: 100%;

              &:focus,
              &:focus-visible {
                outline: 0;
              }
            }

            textarea {
              color: var(--font-color);
              font-size: var(--base-font-size);
              line-height: 1.6;
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              background: 0 0;
              max-width: 100%;
              border-radius: var(--block-border-radius);
              scrollbar-width: thin;
              scrollbar-color: var(--text-color-transparent40) var(--text-color-transparent10);
              min-height: 100px;
              border: 1px solid var(--border-color);
              padding: 10px;

              &:focus,
              &:focus-visible {
                outline: 0;
              }
            }
          }

          .form-item-full {
            width: 100% !important;
          }

          .franchise-btn {
            width: 100%;

            .btn {
              user-select: none;
              display: inline-block;
              padding: 10px calc(15px + 20px);
              width: auto;
              margin: 0;
              position: relative;
              overflow: hidden;
              text-decoration: none;
              text-align: center;
              vertical-align: middle;
              line-height: 1.6;
              cursor: pointer;
              border: 0;
              -webkit-appearance: none;
              -moz-appearance: none;
              border-radius: var(--alt-btn-border-radius);
              background-color: rgba(66 43 32 / 1.0);
              color: rgba(232 226 217 / 1.0);
              font-family: var(--button-font-stack);
              font-weight: var(--button-font-weight);
              font-style: var(--button-font-style);
              text-transform: uppercase;
              font-size: 14px;
              letter-spacing: 2px;
            }

            .btn:not(:disabled):not(.standalone-icon--wrapper):not(.swiper-button-disabled):not(.disabled):not(.btn--secondary):hover:after {
              background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
              content: "";
              height: 100%;
              left: 150%;
              position: absolute;
              top: 0;
              transform: skew(-20deg);
              width: 200%;
              animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
            }
          }
        }
      }
    }
  }
}

.kb-enabled {
  overflow: hidden;
}

@media only screen and (min-width: 768px) {
  .franchise {
    .franchise-section {
      .breadcrumbs a {
        background-color: transparent !important;
        background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
        background-repeat: no-repeat;
        background-position: left bottom, left bottom;
        background-size: 0 1px, 100% 1px;
        transition-property: background-size;
        transition-timing-function: ease;
        transition-duration: .25s;
      }

      .breadcrumbs a:hover {
        background-position: left bottom, left bottom;
        background-size: 100% 1px, 100% 1px;
      }

      .franchise-section-cont1 {
        .cont1-bk {
          min-height: auto;

          .cont1-bk-inner {
            align-items: center;
            justify-content: center;

            .cont1-bk-inner-cont {
              padding: 60px;

              .cont1-bk-inner-cont-font {
                max-width: 100%;

                p {
                  font-size: 36px;
                  text-align: center;
                  margin: 0;
                }
              }
            }
          }
        }
      }

      .franchise-section-cont2 {
        height: 600px;

        .franchise-section-cont2-inner {
          .franchise-section-cont2-inner-cont {
            width: 65%;
            height: 100%;
            margin: 0 auto;
            padding: 20px 0;
            display: flex;

            .franchise-section-cont2-inner-cont-left {
              width: 50%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;

              .franchise-section-cont2-inner-cont-left-box {
                width: 300px;
                height: 300px;
                border-radius: 50%;
                background: linear-gradient(135deg, #345e4b, #457a64);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .franchise-section-cont2-inner-cont-left-box-font {
                  color: #fff;

                  p {
                    display: flex;
                    flex-direction: column;
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    align-items: center;

                    strong {
                      font-size: 38px;

                      &:first-child {
                        font-size: 50px;
                      }
                    }
                  }

                  h5 {
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    text-align: center;
                  }
                }
              }

              .franchise-section-cont2-inner-cont-left-font {
                font-family: var(--bs-body-font-family);
                font-size: 20px;

                p {
                  &:first-child {
                    margin: 0;
                  }
                }
              }
            }

            .franchise-section-cont2-inner-cont-right {
              width: 80%;
              height: 100%;
              display: flex;
              flex-direction: column-reverse;
              position: relative;

              .franchise-section-cont2-inner-cont-right-box {
                width: 400px;
                height: 400px;
                border-radius: 50%;
                background: linear-gradient(135deg, #04415c, #095c80);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .boxSpan {
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  display: block;
                  background: #b1bcad;
                  position: absolute;
                  left: 24%;
                  top: 21%;
                  transform: translateY(-50%);

                  &::before {
                    content: "";
                    width: 4px;
                    height: 200px;
                    display: block;
                    background: #b1bcad;
                    transform: translateY(-98%) translateX(70%);
                  }
                }

                .franchise-section-cont2-inner-cont-right-box-font {
                  color: #fff;

                  p {
                    display: flex;
                    flex-direction: column;
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    align-items: center;

                    strong {
                      font-size: 50px;

                      &:first-child {
                        font-size: 70px;
                      }
                    }
                  }

                  h5 {
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    text-align: center;
                  }
                }
              }

              .franchise-section-cont2-inner-cont-right-font {
                font-family: var(--bs-body-font-family);
                position: absolute;
                left: 123px;
                top: 22px;
                width: 100%;

                p {
                  font-size: 20px;

                  strong {
                    font-size: 50px;
                    color: #176082;
                  }

                  &:first-child {
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }

      .franchise-section-cont1-title {
        padding-top: 60px;
        padding-bottom: 40px;
      }

      .franchise-section-cont3 {
        .franchise-section-cont3-cont {
          justify-content: center;
          align-items: center;
          min-height: 550px;
          padding: 60px;

          .franchise-section-cont3-cont-inner {
            width: 100%;
            max-width: 100%;

            .franchise-section-cont3-cont-inner-title {
              align-self: center;
              text-align: center;
              font-size: 80px;
            }

            .franchise-section-cont3-cont-inner-font {
              align-self: center;
              text-align: center;
              font-size: 16px;

              p {
                font-size: 16px;
              }
            }

            .franchise-section-cont3-cont-inner-image {
              .franchise-section-cont3-cont-inner-image-box {
                width: 85%;
                max-width: 85%;
                height: 100%;
                max-height: 100%;
                transform: translateX(calc(-50% + 50%))
              }
            }
          }
        }
      }

      .franchise-section-cont4 {
        padding: 10px 60px 60px;

        .franchise-section-text {
          form {
            .form-item {
              width: calc(50% - 10px);
            }
          }
        }
      }
    }
  }

  /* 图片动画 - 从大变小 */
  .kb-enabled>* {
    transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
    transform-origin: left center;
    transition: transform 2s ease;
  }

  /* 添加延迟，确保动画触发 */
  .kb-enabled.in-viewport>* {
    animation: scaleDown 2s ease forwards;
    transform-origin: left center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .kb-enabled>* {
    transition: none !important;
  }
}
@media screen and (max-width:1450px) {
  .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont{
    width: 80%!important;
  }
  
}
@media screen and (max-width:1300px) {
  .franchise .franchise-section .timeline-container-cont{
    width: 85%;
  }
}
@media screen and (max-width:1200px) {
  .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont{
    width: 90%!important;
  }
  
}
@media (max-width: 1115px) {
  .franchise {
    padding: var(--nav-1115-height) 0 0;
  }

  .franchise .franchise-section .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont {
    width: 76%;
  }
}
@media screen and (max-width:1050px){
  .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont{
    width: 100%!important;
  }
}
@media (max-width: 990px) {
  .franchise {
    padding: var(--nav-990-height) 0 0;
  }

  .franchise .franchise-section .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont {
    width: 100%;
  }

  .franchise .franchise-section .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont .franchise-section-cont2-inner-cont-right .franchise-section-cont2-inner-cont-right-font {
    width: initial;
  }
}

@media (max-width: 768px) {
  .franchise {
    .franchise-section {
      #breadcrumbs {
        padding-left: 10px;
        padding-right: 10px;
      }

      .cont1-bk {
        .cont1-bk-inner {
          .cont1-bk-inner-cont {
            .cont1-bk-inner-cont-font {
              p {
                text-align: center;
                margin: 0;
              }
            }
          }
        }
      }

      .franchise-section-cont2 {
        height: auto;

        .franchise-section-cont2-inner {
          .franchise-section-cont2-inner-cont {
            width: 100%;
            height: 100%;
            margin: 0 auto;
            padding: 56px 0 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 50px;

            .franchise-section-cont2-inner-cont-left {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              gap: 30px;

              .franchise-section-cont2-inner-cont-left-box {
                width: 300px;
                height: 300px;
                border-radius: 50%;
                background: linear-gradient(135deg, #345e4b, #457a64);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .franchise-section-cont2-inner-cont-left-box-font {
                  color: #fff;

                  p {
                    display: flex;
                    flex-direction: column;
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    align-items: center;

                    strong {
                      font-size: 38px;

                      &:first-child {
                        font-size: 50px;
                      }
                    }
                  }

                  h5 {
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    text-align: center;
                  }
                }
              }

              .franchise-section-cont2-inner-cont-left-font {
                font-family: var(--bs-body-font-family);
                font-size: 20px;

                p {
                  &:first-child {
                    margin: 0;
                  }
                }
              }
            }

            .franchise-section-cont2-inner-cont-right {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              position: relative;
              align-items: center;

              .franchise-section-cont2-inner-cont-right-box {
                width: 400px;
                height: 400px;
                border-radius: 50%;
                background: linear-gradient(135deg, #04415c, #095c80);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .boxSpan {
                  display: none;

                  &::before {
                    content: "";
                    width: 4px;
                    height: 200px;
                    display: block;
                    background: #b1bcad;
                    transform: translateY(-98%) translateX(70%);
                  }
                }

                .franchise-section-cont2-inner-cont-right-box-font {
                  color: #fff;

                  p {
                    display: flex;
                    flex-direction: column;
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    align-items: center;

                    strong {
                      font-size: 50px;

                      &:first-child {
                        font-size: 70px;
                      }
                    }
                  }

                  h5 {
                    font-family: system-ui;
                    font-weight: var(--body-font-weight);
                    font-style: var(--body-font-style);
                    -webkit-font-smoothing: antialiased;
                    -webkit-text-size-adjust: 100%;
                    text-align: center;
                  }
                }
              }

              .franchise-section-cont2-inner-cont-right-font {
                font-family: var(--bs-body-font-family);

                p {
                  font-size: 20px;
                  text-align: center;

                  strong {
                    font-size: 50px;
                    color: #176082;
                  }

                  &:first-child {
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 400px) {
  .franchise .franchise-section .franchise-section-cont2 .franchise-section-cont2-inner .franchise-section-cont2-inner-cont .franchise-section-cont2-inner-cont-right  .franchise-section-cont2-inner-cont-right-box {
    width: 100vw;
    height: 100vw;
  }
}
</style>